// List of file type code-prefixes for excluding files depending on locale.
export const STORM_MEDIA_URL = process.env.REACT_APP_STORM_MEDIA_URL;

export const INGRID_WIDGET_URL = process.env.REACT_APP_INGRID_WIDGET_URL;

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

// dynamic placeholder filenames?
export const PLACEHOLDER = `${process.env.REACT_APP_MEDIA_URL}/placeholder.png`;

export const APP_ORGANIZATION = 'Fogia';
export const AFFILIATION = 'Fogia AB';

export const STORM_IMAGE_URL = process.env.REACT_APP_STORM_MEDIA_URL;
